/* =========================================================
LAZY LOADING IMAGES
========================================================= */
document.addEventListener("DOMContentLoaded", function(){
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  if("IntersectionObserver" in window){
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove("lazy");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });
    lazyImages.forEach(function(lazyImage){
      lazyImageObserver.observe(lazyImage);
    });
  }
  var show = true;
});

let lazyObserver = null;

function initLazyObserver() {
  if ("IntersectionObserver" in window) {
    lazyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.remove("lazy");
          lazyObserver.unobserve(img);
        }
      });
    });
  }
}

initLazyObserver();

function observeLazyImages() {
  if (!lazyObserver) return;

  const lazyImages = document.querySelectorAll("img.lazy");
  lazyImages.forEach(img => lazyObserver.observe(img));
}


/* =========================================================
VIEWPORT HEIGHT (--h / --m)
========================================================= */
document.addEventListener('DOMContentLoaded', function(){
  var w = window.innerWidth,
      h = window.innerHeight;
  document.documentElement.style.setProperty('--h', h + 'px');

  m = document.getElementById("header").offsetHeight;
  document.documentElement.style.setProperty('--m', m + 'px');
});

window.addEventListener("resize", onResizeFunction);
function onResizeFunction (e){
  var w = window.innerWidth,
      h = window.innerHeight;
  document.documentElement.style.setProperty('--h', h + 'px');

  m = document.getElementById("header").offsetHeight;
  document.documentElement.style.setProperty('--m', m + 'px');
}


/* =========================================================
WISHLIST (LOCAL STORAGE)
========================================================= */
document.addEventListener("DOMContentLoaded", function () {

  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  document.querySelectorAll(".wishlist-btn").forEach(btn => {
    const handle = btn.dataset.productHandle;

    if (wishlist.includes(handle)) {
      btn.classList.add("active");
      btn.querySelector(".wishlist-icon").textContent = "★";
    } else {
      btn.querySelector(".wishlist-icon").textContent = "☆";
    }

    btn.addEventListener("click", () => {
      const index = wishlist.indexOf(handle);

      if (index > -1) {
        wishlist.splice(index, 1);
        btn.classList.remove("active");
        btn.querySelector(".wishlist-icon").textContent = "☆";
      } else {
        wishlist.push(handle);
        btn.classList.add("active");
        btn.querySelector(".wishlist-icon").textContent = "★";
      }

      localStorage.setItem("wishlist", JSON.stringify(wishlist));
    });
  });
});


/* =========================================================
SEARCH INPUT BEHAVIOUR
========================================================= */
document.addEventListener("DOMContentLoaded", function () {

  const search = document.querySelector('.search');
  const input = search.querySelector('input[type="text"]');
  const button = search.querySelector('button[type="submit"]');

  let submitting = false;

  button.addEventListener('mousedown', function () {
    submitting = true;
  });

  input.addEventListener('focus', function () {
    input.placeholder = input.dataset.active;
    button.hidden = false;
    search.classList.add('is-active');
  });

  input.addEventListener('blur', function () {
    if (submitting) return;

    if (!input.value) {
      input.placeholder = input.dataset.default;
      button.hidden = true;
      search.classList.remove('is-active');
    }
  });

  search.querySelector('form').addEventListener('submit', function () {
    submitting = false;
  });


/* =========================================================
CATEGORIES SCROLL LOCK
========================================================= */
  const categories = document.querySelector('.categories');

  if (categories.classList.contains('active')) {
    document.body.classList.add('no-scroll');
  } else {
    document.body.classList.remove('no-scroll');
  }


/* =========================================================
BUY BLOCK (MOBILE SCROLL)
========================================================= */
  const buyBlock = document.querySelector('.buy-block');
  if (!buyBlock) return;

  let hasActivated = false;
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  function handleScroll() {
    if (!mobileQuery.matches) return;

    const scrollY = window.scrollY;

    if (scrollY > 100 && !hasActivated) {
      buyBlock.classList.add('vissible');
      hasActivated = true;
    }

    if (scrollY === 0) {
      buyBlock.classList.remove('vissible');
      hasActivated = false;
    }
  }

  window.addEventListener('scroll', handleScroll);
});


/* =========================================================
BREADCRUMBS (SCROLL HIDE / SHOW)
========================================================= */
let lastScrollTop = 0;
const threshold = 60;
const $breadcrumbs = $('.breadcrumbs');

$(window).on('scroll', function () {
  const scrollTop = $(this).scrollTop();
  const diff = scrollTop - lastScrollTop;

  if (diff > threshold) {
    $breadcrumbs.stop(true).animate({ opacity: 0 }, 0);
    lastScrollTop = scrollTop;
  }

  if (diff < -threshold) {
    $breadcrumbs.stop(true).animate({ opacity: 1 }, 0);
    lastScrollTop = scrollTop;
  }
});


/* =========================================================
(JQUERY)
========================================================= */
$(document).ready(function() {

  /* -----------------------------------------
  DURABILITY CLOSE
  ----------------------------------------- */
  $('.close-durability').on('click', function () {
    $(this).closest('.product-duration').fadeOut(200);
  });


  /* -----------------------------------------
  CART DRAWER OBSERVER
  ----------------------------------------- */
  const drawer = document.querySelector('#cart-drawer');
  if (!drawer) return;

  const observer = new MutationObserver(() => {
    if (drawer.getAttribute('aria-hidden') === 'false') {
      $('.discount').stop(true, true).slideUp(250);
    }
  });

  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ['aria-hidden']
  });


  /* -----------------------------------------
  QUICK ADD – SOLD STATE
  ----------------------------------------- */
  document.querySelectorAll('.quick-add-btn[aria-disabled="true"]').forEach(btn => {
    btn.classList.add('soldie');
  });




  /* -----------------------------------------
  CATEGORIES / MENU TOGGLES
  ----------------------------------------- */
  $('.close-categories').click(function() {
    $('.categories').toggleClass("active");
    $('.shop').removeClass("active");
  });

  $('#cart').click(function() {
    $('.categories').removeClass("active");
  });

  $('a.hidden.close-menu').click(function () {
    $('.menu-mobile').toggleClass('active');
    $('header').toggleClass('active');

    if ($('.menu-mobile').hasClass('active')) {
      $(this).text('Fermer');
    } else {
      $(this).text('Menu');
    }
  });



  $('.shop').click(function() {
    $('.categories').toggleClass("active");
  });


  /* -----------------------------------------
  CLICK OUTSIDE (CLOSE MENUS)
  ----------------------------------------- */
  $(document).click(function(e) {
    if (!$(e.target).closest('.shop, .categories, #cart, .CartDrawer__panel, .menu').length) {
      $('.categories').removeClass('active');
      $('#products').css('pointer-events', 'auto');
    }
  });


  /* -----------------------------------------
  TOGGLE BLOCKS (ACCORDION)
  ----------------------------------------- */
  $('.toggle-btn').on('click', function() {
    const $block = $(this).closest('.toggle-block');
    const $icon = $(this).find('.icon');

    $('.toggle-block.active').not($block).each(function() {
      $(this).removeClass('active');
      $(this).find('.toggle-content').slideUp(200);
      $(this).find('.icon').text('+');
    });

    $block.toggleClass('active');
    $block.find('.toggle-content').slideToggle(200);
    $icon.text($block.hasClass('active') ? '–' : '+');
  });

});


/* =========================================================
CATEGORIES FINAL SCROLL LOCK WATCHER
========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  const categories = document.querySelector('.categories');
  if (!categories) return;

  setInterval(function () {
    document.body.classList.toggle(
      'no-scroll',
      categories.classList.contains('active')
    );
  }, 100);
});

/* =========================================================
SWIPER
========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.blog-swiper').forEach((el) => {
    if (el.swiper) return;

    const swiper = new Swiper(el, {
      slidesPerView: 4,
      spaceBetween: 5,
      watchOverflow: true,

      observer: true,
      observeParents: true,
      resizeObserver: true,
      updateOnWindowResize: true,

      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },

      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },

      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 15 },
        600: { slidesPerView: 1, spaceBetween: 15 },
        700: { slidesPerView: 2, spaceBetween: 5 },
        1350: { slidesPerView: 3, spaceBetween: 5 },
        1600: { slidesPerView: 4, spaceBetween: 5 }
      }
    });

    const prevBtn = el.querySelector('.swiper-button-prev');
    const nextBtn = el.querySelector('.swiper-button-next');

    const updateNavState = () => {
      if (prevBtn) prevBtn.classList.toggle('is-disabled', swiper.isBeginning);
      if (nextBtn) nextBtn.classList.toggle('is-disabled', swiper.isEnd);
    };

    updateNavState();

    swiper.on('slideChange', updateNavState);
    swiper.on('resize', updateNavState);
    swiper.on('breakpoint', updateNavState);
    swiper.on('update', updateNavState);

    const controls = el.querySelector('.controls');

    if (controls) {
      const toggleControls = () => {
        controls.style.display = swiper.isLocked ? 'none' : '';
      };

      toggleControls();

      swiper.on('resize', toggleControls);
      swiper.on('breakpoint', toggleControls);
      swiper.on('slidesLengthChange', toggleControls);
    }

    let resizeTimeout;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        swiper.update();
      }, 150);
    });
  });
});




document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.hero-swiper').forEach((el) => {
    if (el.swiper) return;

    const prevBtn = el.querySelector('.hero-prev');
    const nextBtn = el.querySelector('.hero-next');

    const swiper = new Swiper(el, {
      slidesPerView: 1,
      loop: true,
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });

    /* =========================
       NAV THUMBNAILS
    ========================== */

    function updateNavImages() {
      const activeIndex = swiper.activeIndex;

      const prevSlide =
        swiper.slides[activeIndex - 1] ||
        swiper.slides[swiper.slides.length - 1];

      const nextSlide =
        swiper.slides[activeIndex + 1] ||
        swiper.slides[0];

      const prevImg = prevSlide?.querySelector('img')?.src;
      const nextImg = nextSlide?.querySelector('img')?.src;

      if (prevImg && prevBtn) {
        prevBtn.style.backgroundImage = `url(${prevImg})`;
      }

      if (nextImg && nextBtn) {
        nextBtn.style.backgroundImage = `url(${nextImg})`;
      }
    }

    swiper.on('init', updateNavImages);
    swiper.on('slideChange', updateNavImages);

    updateNavImages();

    /* =========================
       PROGRESS BAR
    ========================== */

    function resetAllBars() {
      el.querySelectorAll('.hero-progress__bar').forEach((bar) => {
        bar.style.transition = 'none';
        bar.style.transform = 'translateX(-100%)';
      });
    }

    function animateActiveBar() {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      const bar = activeSlide.querySelector('.hero-progress__bar');
      if (!bar) return;

      bar.style.transition = 'none';
      bar.style.transform = 'translateX(-100%)';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          bar.style.transition = 'transform 3.8s linear';
          bar.style.transform = 'translateX(0)';
        });
      });
    }

    resetAllBars();
    animateActiveBar();

    swiper.on('slideChangeTransitionStart', () => {
      resetAllBars();
      animateActiveBar();
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.product-swiper').forEach((el) => {
    if (el.swiper) return;

    const prevBtn = el.querySelector('.product-prev');
    const nextBtn = el.querySelector('.product-next');

    const swiper = new Swiper(el, {
      slidesPerView: 1,
      loop: true,
      speed: 800,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });

    el.addEventListener('click', function (e) {
      const rect = el.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const middle = rect.width / 2;

      if (clickX < middle) {
        swiper.slidePrev();
      } else {
        swiper.slideNext();
      }
    });
    /* =========================
       NAV THUMBNAILS
    ========================== */

    function updateNavImages() {
      const activeIndex = swiper.activeIndex;

      const prevSlide =
        swiper.slides[activeIndex - 1] ||
        swiper.slides[swiper.slides.length - 1];

      const nextSlide =
        swiper.slides[activeIndex + 1] ||
        swiper.slides[0];

      const prevImg = prevSlide?.querySelector('img')?.src;
      const nextImg = nextSlide?.querySelector('img')?.src;

      if (prevImg && prevBtn) {
        prevBtn.style.backgroundImage = `url(${prevImg})`;
      }

      if (nextImg && nextBtn) {
        nextBtn.style.backgroundImage = `url(${nextImg})`;
      }
    }

    swiper.on('init', updateNavImages);
    swiper.on('slideChange', updateNavImages);

    updateNavImages();
  });
});




document.addEventListener('submit', function (e) {
  const form = e.target.closest('form.quick-add-form');
  if (!form) return;

  e.preventDefault(); // ⛔️ bloquea submit normal

  const btn = form.querySelector('.quick-add-btn');
  btn?.classList.add('is-loading');

  const formData = new FormData(form);

  // 👉 usa TU sistema
  window.addToCartCustom(formData);

  // feedback UX
  setTimeout(() => {
    btn?.classList.remove('is-loading');
    window.__openCartDrawer();
  }, 150);
});


/* =====================================================
   SUBSCRIPTION SYSTEM – PER PRODUCT (FINAL VERSION)
===================================================== */

(function () {

  const SUBSCRIPTION_DISCOUNT = 20;

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  /* ---------------------------------
     UPDATE PRODUCT PAGE PRICE
  --------------------------------- */

  function updateProductPagePrice(selected) {

    const priceBox = document.querySelector('.product-price[data-base-price]');
    if (!priceBox) return;

    const basePrice = parseInt(priceBox.dataset.basePrice, 10);
    const priceCurrent = priceBox.querySelector('.price-current');
    const priceCompare = priceBox.querySelector('.price-compare');

    if (!basePrice || !priceCurrent) return;

    if (selected === 'subscription') {

      const discounted = Math.round(
        basePrice * (100 - SUBSCRIPTION_DISCOUNT) / 100
      );

      priceCurrent.textContent = formatMoney(discounted);

      if (priceCompare) {
        priceCompare.textContent = formatMoney(basePrice);
        priceCompare.style.display = 'inline';
      }

    } else {

      priceCurrent.textContent = formatMoney(basePrice);

      if (priceCompare) {
        priceCompare.style.display = 'none';
      }
    }
  }

  /* ---------------------------------
     APPLY GRID BADGE STATE
  --------------------------------- */
 function applyGridState() {
  const savedType = localStorage.getItem('purchase_type');
  const savedId = localStorage.getItem('subscription_product_id');

  document.querySelectorAll('.product').forEach(card => {

    const badge = card.querySelector('.product-duration');
    const priceBox = card.querySelector('.product-price');

    if (!priceBox) return;

    const cardId = card.id.replace('product-', '');
    const basePrice = parseInt(priceBox.dataset.price, 10);
    const priceCurrent = priceBox.querySelector('.price-current');
    let priceCompare = priceBox.querySelector('.price-compare');

    if (!basePrice || !priceCurrent) return;

    const isActive =
      savedType === 'subscription' &&
      savedId &&
      savedId === cardId;

    /* Badge */
    if (badge) {
      badge.classList.toggle('active', isActive);
    }

    /* Price logic */
    if (isActive) {

      const discounted = Math.round(basePrice * 0.8);

      priceCurrent.textContent = formatMoney(discounted);

      if (!priceCompare) {
        priceCompare = document.createElement('s');
        priceCompare.classList.add('price-compare');
        priceBox.prepend(priceCompare);
      }

      priceCompare.textContent = formatMoney(basePrice);
      priceCompare.style.display = 'inline';

    } else {

      priceCurrent.textContent = formatMoney(basePrice);

      if (priceCompare) {
        priceCompare.style.display = 'none';
      }
    }

  });

}


  /* ---------------------------------
     HANDLE PURCHASE CHANGE
  --------------------------------- */

  document.addEventListener('change', function (e) {

    if (e.target.name === 'purchase_option') {

      const value = e.target.value;

      localStorage.setItem('purchase_type', value);

      const productWrapper = document.querySelector('#main-product');
      const productId = productWrapper?.dataset.productId;

      if (value === 'subscription' && productId) {
        localStorage.setItem('subscription_product_id', productId);
      }

      if (value === 'one_time') {
        localStorage.removeItem('subscription_product_id');
      }

      updateProductPagePrice(value);
      applyGridState();
    }

    if (e.target.classList.contains('subscription-select')) {
      localStorage.setItem('selling_plan', e.target.value);
    }

  });

  /* ---------------------------------
     RESTORE STATE ON LOAD
  --------------------------------- */

function restoreState() {

  const saved = localStorage.getItem('purchase_type');
  if (!saved) return;

  const radio = document.querySelector(
    `[name="purchase_option"][value="${saved}"]`
  );

  if (radio) {
    radio.checked = true;
    updateProductPagePrice(saved);

    // 🔥 Mostrar / ocultar subscription box
    const wrapper = radio.closest('.purchase-options');
    const subscriptionBox = wrapper?.querySelector('.subscription-options');

    if (subscriptionBox) {
      subscriptionBox.hidden = (saved !== 'subscription');
    }
  }

  applyGridState();
}


  document.addEventListener('DOMContentLoaded', restoreState);
  document.addEventListener('shopify:section:load', restoreState);

})();

document.addEventListener('change', function (e) {

  if (e.target.name === 'purchase_option') {

    const value = e.target.value;
    const wrapper = e.target.closest('.purchase-options');
    const subscriptionBox = wrapper?.querySelector('.subscription-options');

    if (subscriptionBox) {
      subscriptionBox.hidden = (value !== 'subscription');
    }

    localStorage.setItem('purchase_type', value);

    const productWrapper = document.querySelector('#main-product');
    const productId = productWrapper?.dataset.productId;

    if (value === 'subscription' && productId) {
      localStorage.setItem('subscription_product_id', productId);
    }

    if (value === 'one_time') {
      localStorage.removeItem('subscription_product_id');
    }

    updateProductPagePrice(value);
    applyGridState();
  }

});

document.addEventListener('DOMContentLoaded', function () {

  const header = document.querySelector('header');
  if (!header) return;

  window.addEventListener('scroll', function () {

    if (window.scrollY > 50) {
      header.classList.add('back');
    } else {
      header.classList.remove('back');
    }

  });

});

